type To = 'Bytes' | 'KB' | 'MB' | 'GB' | 'TB' | 'PB' | 'EB' | 'ZB' | 'YB';

export function FormatBytes(bytes: number, to: To): number {
  if (bytes === 0) return 0;
  const sizes: To[] = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const divider = 1024 ** (sizes.indexOf(to));
  return bytes / Math.max(1, divider);
}
